// extracted by mini-css-extract-plugin
export default {"editButton":"hrStop_editButton__RhBbe","TableBody":"hrStop_TableBody__vKykQ","StopButton":"hrStop_StopButton__Y1DE-"};